import { render, staticRenderFns } from "./TicketsPopupOrder.vue?vue&type=template&id=2c0d8c3e&scoped=true&"
import script from "./TicketsPopupOrder.vue?vue&type=script&lang=js&"
export * from "./TicketsPopupOrder.vue?vue&type=script&lang=js&"
import style0 from "./TicketsPopupOrder.vue?vue&type=style&index=0&id=2c0d8c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d8c3e",
  null
  
)

export default component.exports